import React from 'react';
import HeaderItem from "./HeaderItem";

class Header extends React.Component {

    render() {
        const user = this.props.user;
        const total = this.props.total;

        // Safety: voorkom crashes als days nog undefined is
        const days = Array.isArray(this.props.days) ? this.props.days : [];

        // Vakantie dagen (actuele + in aanvraag)
        const restVakantie =
            user && user.RestAantalVakantieDagen != null
                ? user.RestAantalVakantieDagen
                : "...";

        const aangevraagd =
            user && user.AangevraagdeVakantieDagen != null
                ? user.AangevraagdeVakantieDagen
                : 0;

        // ⭐ Nieuwe logica: rood < 40, groen ≥ 40
        // 🎯 Doeluren per week uit Mendix-user (fallback = 40)
		const targetHours =
			user && user.WerkurenPerWeek != null
				? user.WerkurenPerWeek
				: 40;

		// 🎨 Kleur op basis van contracturen
		const cls = total >= targetHours ? "success-color" : "error-color";


        const headerItems = days.map(date => (
            <HeaderItem key={date.date} date={date} />
        ));

        return (
            <div
                className={
                    this.props.showWeekend
                        ? "open registration-table-header clear"
                        : "registration-table-header clear"
                }
            >
                <div className="offset remove-on-mobile table-details">

                    {/* WEEK EN TOTAAL */}
                    <div className="float-left" style={{ height: "initial", width: "125px" }}>
                        <div className="strong">
                            <span className="head">Week:</span>
                            <span>{this.props.week}</span>
                        </div>

                        <div className="strong" title="Geboekte uren">
                            <span className="head">Totaal:</span>
                            <span className={cls}>{total}</span>
                        </div>
                    </div>

                    {/* VAKANTIEDAGEN */}
                    <div className="col-6 float-left" style={{ height: "initial", width: "150px" }}>
                        <div className="strong">
                            <span className="head" style={{ width: "120px" }}>Vakantiedagen:</span>
                            <span>{restVakantie}</span>
                        </div>

                        <div className="strong">
                            <span className="head" style={{ width: "120px" }}>In aanvraag:</span>
                            <span>{aangevraagd}</span>
                        </div>
                    </div>
                </div>

                {headerItems}
            </div>
        );
    }

    updateOffTime() {
        if (this.props.fetchUser) {
            this.props.fetchUser();
        }
    }
}

export default Header;
